const searchChannels = {
    searchChannelElement: null,
    infoBox: null,
    value: null,
    re: null,
    channels: [],
    lastKeyCode: null,
    init: function(context, searchId) {
        this.findSearchInput(searchId || 'searchChannels');
        if (!this.searchChannelElement) return;

        this.channels = this.prepareObjectToSearch(this.findAllChannels(context || document));
        this.getValue();
        this.createClearInputEvent();
    },
    findSearchInput: function(searchId) {
        this.searchChannelElement = document.querySelector(`#${searchId}`)
    },
    changeValue: function(value) {
        return this.value = value;
    },
    changeRe: function() {
        return this.re = new RegExp(this.value, 'i');
    },
    getValue: function() {
        this.searchChannelElement.addEventListener('keyup', e => this.detectEnterKey(e.keyCode));
        this.searchChannelElement.addEventListener('keydown', e => this.lastKeyCode = e.keyCode);
    },
    changeValueEvent: function() {
        this.changeValue(this.searchChannelElement.value);
        this.changeTab('.packages-tabs .packages-tabs__item');
        this.changeRe();
        this.changeIconDependsOnValue();

        const filtered = this.channels.filter(channel => this.re.test(channel.channel));

        this.channels.forEach(channel => {
            channel.element.classList.remove('in-package');
            if (this.getUniqueFoundedChannels(filtered).length != 0) {
                channel.element.classList.add('not-in-package');
                channel.element.setAttribute('aria-hidden', 'true');
            } else {
                channel.element.classList.remove('not-in-package');
                channel.element.setAttribute('aria-hidden', 'false');
            }
        });

        this.prepareInfoAboutFoundedChannels(this.getUniqueFoundedChannels(filtered).length);

        filtered.forEach(channel => {
            if (channel.element.parentElement.classList.contains('hiddenPackages')) {
                this.dispatchMoreCircleClick(channel.element.parentElement.previousSibling);
            }
            channel.element.classList.remove('not-in-package');
            channel.element.classList.add('in-package');
            channel.element.setAttribute('aria-hidden', 'false');
        });
        const that = this;
        setTimeout(function() {
            that.infoBox.focus();
        }, 100);
    },
    prepareInfoAboutFoundedChannels: function(amount) {
        if (!this.infoBox) {
            this.infoBox = document.createElement('p');
            this.infoBox.classList.add('search-channels__info');
            this.infoBox.setAttribute('role', 'alert');
            this.infoBox.setAttribute('tabindex', '-1');
        }

        this.setTextInInfoBox(amount);
        this.searchChannelElement.parentElement.appendChild(this.infoBox);
    },
    setTextInInfoBox: function(amount) {
        const results1 = this.searchChannelElement.getAttribute('data-text-results1');
        const results2 = this.searchChannelElement.getAttribute('data-text-results2');
        const results5 = this.searchChannelElement.getAttribute('data-text-results5');
        const regularName = amount === 1 ? results1 : amount < 5 ? results2 : results5;
        const notFoundMsg = this.searchChannelElement.getAttribute('data-text-noresults');
        let foundMsg = this.searchChannelElement.getAttribute('data-text-results');
        foundMsg = foundMsg.replace('{0}', this.searchChannelElement.value);
        foundMsg = foundMsg.replace('{1}', amount);
        foundMsg = foundMsg.replace('{2}', regularName);

        // const notFoundMsg = 'Nie znaleźliśmy kanałów o takiej nazwie';        

        if (this.searchChannelElement.value && amount > 0) {
            return this.infoBox.innerText =
                foundMsg;
            // `dla "${this.searchChannelElement.value}" znaleziono ${amount} ${regularName}`;
        }

        if (!arguments.length) {
            if (this.infoBox) {
                return this.infoBox.innerText = '';
            }
        }

        if (this.infoBox) {
            return this.infoBox.innerText = notFoundMsg;
        }
    },
    getUniqueFoundedChannels: function(arr) {
        return [...new Set(arr.map(item => item.channel))];
    },
    detectLengthOfValue: function() {
        return this.searchChannelElement.value.length;
    },
    changeIconDependsOnValue: function() {
        const btn = this.searchChannelElement.nextElementSibling;
        const btnSpan = btn.querySelector("span");
        if (this.detectLengthOfValue()) {
            this.searchChannelElement.classList.add('filledInput');
            if (btn.getAttribute("data-text-clear")) {
                btnSpan.innerText = btn.getAttribute("data-text-clear");
            }
        } else {
            this.searchChannelElement.classList.remove('filledInput');
            if (btn.getAttribute("data-text-search")) {
                btnSpan.innerText = btn.getAttribute("data-text-search");
            }
        }
    },
    detectEnterKey: function(key) {
        if (key !== 13) return;
        this.changeValueEvent();
    },
    changeTab: function(tabSelector) {
        const event = document.createEvent('Event');
        event.initEvent('click', false, true);
        const tabs = document.querySelector(tabSelector)
        if (tabs == null) return;
        tabs.dispatchEvent(event);
    },
    findAllChannels: function(context) {
        return context.querySelectorAll('[data-channel]')
    },
    prepareObjectToSearch: function(nodeList) {
        return Array.from(nodeList).map((element) => {
            return {
                channel: element.dataset.channel,
                element: element
            }
        });
    },
    createClearInputEvent: function() {
        const btn = this.searchChannelElement.nextElementSibling;
        btn.addEventListener('click', _ => {
            this.lastKeyCode = 13;
            if (btn.previousElementSibling.classList.contains('filledInput')) {
                this.clearInput(btn);
                btn.focus();
                return;
            }
            this.changeValueEvent();
        });
    },
    clearInput: function() {
        if (!this.searchChannelElement.classList.contains('filledInput')) return;

        this.searchChannelElement.value = null;
        this.searchChannelElement.classList.remove('filledInput');
        this.searchChannelElement.classList.remove('filled');

        this.dispatchChangeEvent();
        this.findAllHiddenPackagesWrappers();
        this.channels.forEach(channel => {
            channel.element.classList.remove('in-package');
            channel.element.classList.remove('not-in-package');
            channel.element.setAttribute('aria-hidden', 'false');
        });
        this.setTextInInfoBox();
    },
    findAllHiddenPackagesWrappers: function() {
        const hiddenPackages = document.querySelectorAll('.hiddenPackages');

        hiddenPackages.forEach(pack => {
            if (!pack.style.display || pack.style.display !== 'none') {
                const packCircle = pack.parentElement.querySelector('.arrow__container');
                this.dispatchMoreCircleClick(packCircle)
            }
        });
    },
    dispatchChangeEvent: function() {
        const event = document.createEvent('Event');
        event.initEvent('change', false, true);
        this.searchChannelElement.dispatchEvent(event);
    },
    dispatchMoreCircleClick: function(target) {
        const event = document.createEvent('Event');
        event.initEvent('click', false, true);
        target.firstElementChild.dispatchEvent(event);
    }
};

export function prepareAllPossibleSearchEngines() {
    const targetsInputs = document.querySelectorAll(`[data-search-engine-for]`);
    // console.log('targetsInputs', targetsInputs);
    if (!targetsInputs.length) return;

    targetsInputs.forEach(target => Object
        .create(searchChannels)
        .init(document.getElementById(`${target.dataset.searchEngineFor}`), target.id))
}